import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AccordionItem from './AccordionItem';

const propTypes = {
  accordions: PropTypes.arrayOf(PropTypes.object),
  isEditing: PropTypes.bool.isRequired,
};

const defaultProps = {
  accordions: [],
};

const getPanelDefaultStates = (accordions) => {
  const panelCloseStates = {};
  accordions.forEach((item) => {
    panelCloseStates[item.id] = item.defaultOpen;
  });
  return panelCloseStates;
};

const Accordion = ({ accordions, isEditing }) => {
  const [panelCloseStates, setPanelCloseStates] = useState(getPanelDefaultStates(accordions));

  const togglePanel = (accordionId) => {
    setPanelCloseStates(prevState => ({
      ...prevState,
      [accordionId]: !prevState[accordionId],
    }));
  };

  return (
    <div>
      {!isEditing && accordions.map(item => (
        <div key={item.id}>
          <AccordionItem
            item={item}
            onToggle={() => togglePanel(item.id)}
            panelCloseStates={panelCloseStates}
          />
        </div>
      ))}
    </div>
  );
};

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;

export default Accordion;
